import OfficeEditorFontSizeDropdown from './OfficeEditorFontSizeDropdown';

export default OfficeEditorFontSizeDropdown;